export default __webpack_public_path__ + "static/media/ebu-id-logo.d11c4b5e.svg";